import { render, staticRenderFns } from "./SanctionPartialMatchList.vue?vue&type=template&id=97e3713a&"
import script from "./SanctionPartialMatchList.vue?vue&type=script&lang=js&"
export * from "./SanctionPartialMatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports